import {Component} from '@angular/core';

@Component({
    selector: 'tfl-bo-card-box-content',
    template: '<ng-content></ng-content>'
})
export class CardBoxContentComponent {}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/card-box/card-box.content.component.ts